import { List, Map, Record } from 'immutable';

const ProductRecord = Record({
    categories: List([]),
    description: '',
    expiresAt: null,
    id: null,
    keywords: List([]),
    listings: List([]),
    media: List([]),
    metadata: Map({}),
    name: '',
    price: null,
    sku: '',
});

function getMediaUrl() {
    return this.getIn(['media', 0, 'url']);
}

ProductRecord.prototype.getMediaUrl = getMediaUrl;

export default ProductRecord;



// WEBPACK FOOTER //
// ./src/records/product.js